import { DataBean } from "../DataBean";

export class StatementMovement extends DataBean {


    public async BankingStatement(idBankingAccount:any,year:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_BankingStatement_Number_Number", [idBankingAccount,year]);
    }
      public async getBankingStatementMovement(documentLocation:any,documentDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBankingStatementMovement_Number_java.util.Date", [documentLocation,documentDate]);
    }
 public async deleteBankingStatementMovement(idBankingStatementMovement:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteBankingStatementMovement_Number", [idBankingStatementMovement]);
    }
 public async deleteBankingStatementData(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteBankingStatementData_Number", [id]);
    }
}